import { useEffect, useState } from "react";

export const useIsAndroid = () => {
  const [isAndroid, setIsAndroid] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const checkIsAndroid = () => {
      // Check if we're in a browser environment
      if (typeof window === "undefined") {
        return false;
      }

      // Check for Android PWA installation indicators
      const userAgent = navigator.userAgent.toLowerCase();

      // Check if running on Android device
      const isAndroidDevice = /android/.test(userAgent);

      if (!isAndroidDevice) {
        return false;
      }

      // Check if it's a PWA - multiple indicators
      const isPWA =
        // Check for standalone display mode (PWA installed)
        window.matchMedia("(display-mode: standalone)").matches ||
        // Check for fullscreen display mode
        window.matchMedia("(display-mode: fullscreen)").matches ||
        // Check for minimal-ui display mode
        window.matchMedia("(display-mode: minimal-ui)").matches ||
        // Check if launched from home screen (Android WebAPK)
        document.referrer?.includes("android-app://") ||
        // Check for Android WebAPK user agent
        userAgent.includes("wv") || // WebView
        // Check for custom user agent added by Android WebAPK
        userAgent.includes("packagename") ||
        // Check navigator standalone for older implementations
        (window.navigator as Navigator & { standalone?: boolean }).standalone === true;

      return isAndroidDevice && isPWA;
    };

    const result = checkIsAndroid();
    setIsAndroid(result);
  }, []);

  return isAndroid;
};
